import { CommonTabbarContext } from "@/App";
import { TAB_TYPE } from "@/commons/enums/tab-type";
import { useContext, useEffect } from "react";
import { Navigate, Route, Routes, useNavigate, useParams } from "react-router-dom";
import { TabRoute } from "@/commons/components/common-tabbar";
import DrawPanel from "@/panel/graphic/draw";
export const DRAW_MAIN_KEY = "draw-main"
export default function TabRoutes() {

    const { projectUuid, modelUuid, branchUuid } = useParams();

    const navigate = useNavigate();
    const tabbarContext = useContext(CommonTabbarContext);

    useEffect(() => {
        // 注册闭包路由方法
        tabbarContext.registerNavigate(navigateTo);
        // 添加默认的tab
        let mainDrawTab: TabRoute = {
            title: "绘图区",
            url: `${TAB_TYPE.DRAW}/${DRAW_MAIN_KEY}`
        }
        tabbarContext.pushRoute(mainDrawTab)
    }, [projectUuid, modelUuid, branchUuid])

    const navigateTo = (url: string) => {
        setTimeout(() => {
            navigate(url)
        }, 0)
    };

    return (
        <Routes>
            <Route path={`${TAB_TYPE.DRAW}/:drawKey`} element={<DrawPanel />} />
            <Route path={`${TAB_TYPE.ROOF_SLAB}/:roofSlabUuid`} element={<DrawPanel tabTitle="绘制屋面板截面" tabClosable={true} />} />
            <Route path={`${TAB_TYPE.GUTTER}/:gutterUuid`} element={<DrawPanel tabTitle="绘制天沟截面" tabClosable={true} />} />
            <Route path="*" element={<Navigate to={`${TAB_TYPE.DRAW}/${DRAW_MAIN_KEY}`} />} />
        </Routes>
    )
}